export default [
  {
    path: '/approve/list',
    name: 'ApproveList',
    component: () => import('@/views/Approve/ApproveList'),
    redirect: {
      name: 'ApproveList_new'
    },
    children: [
      {
        path: 'new',
        name: 'ApproveList_new',
        component: () => import('@/components/approve/ApproveListNew')
      },
      {
        path: 'reconciliation',
        name: 'ApproveList_reconciliation',
        component: () => import('@/components/approve/ApproveListNew')
      },
      {
        path: 'control',
        name: 'ApproveList_control',
        component: () => import('@/components/approve/ApproveListNew')
      },
      {
        path: 'closed',
        name: 'ApproveList_closed',
        component: () => import('@/components/approve/ApproveListNew')
      }
    ]
  }
]
